import { useState } from "react";
import { toast } from "sonner";
import { API } from "../lib/api";

/**
 * "Build for agent" — exports the terminal as a factual, subscription-agnostic
 * tool stack an AI agent (or its builder) can consume: JSON + Markdown + a
 * generic AGENT-README. A map, not access — no prompts, no credentials. Only
 * VERIFIED tool capabilities are emitted, so badges never imply something false.
 */
export const AgentExport = ({ id }) => {
  const [open, setOpen] = useState(false);
  if (!id) return null;

  const base = `${API}/terminals/${encodeURIComponent(id)}/agent-export`;

  const copyJson = async () => {
    try {
      const res = await fetch(`${base}?format=json`);
      const data = await res.json();
      await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
      toast.success("stack JSON copied — paste into your agent");
    } catch {
      toast.error("could not copy — try the download instead");
    }
  };

  return (
    <span className="relative">
      <button
        className="tv-link text-[13px]"
        onClick={() => setOpen((v) => !v)}
        data-testid="build-for-agent-btn"
        title="export this stack for an AI agent"
      >
        [&gt;] Export Agent Toolkit
      </button>

      {open && (
        <div
          className="absolute left-0 top-6 z-20 w-[300px] border border-[#111] bg-white p-3 text-[13px]"
          data-testid="agent-export-panel"
        >
          <div className="text-[11px] uppercase tracking-wide text-[#888] mb-1">
            Export Agent Toolkit
          </div>
          <p className="text-[12px] text-[#555] leading-snug mb-3">
            A factual tool list for your AI agent — a map, not access. Each tool
            is a third-party subscription. No prompts, no credentials.
          </p>
          <div className="flex flex-col gap-1.5">
            <button className="tv-link text-left" onClick={copyJson} data-testid="agent-export-copy-json">
              copy stack JSON
            </button>
            <a className="tv-link" href={`${base}?format=json&download=1`} data-testid="agent-export-dl-json">
              download stack.json
            </a>
            <a className="tv-link" href={`${base}?format=md&download=1`} data-testid="agent-export-dl-md">
              download stack.md
            </a>
            <a className="tv-link" href={`${base}?format=readme&download=1`} data-testid="agent-export-dl-readme">
              download AGENT-README.md
            </a>
          </div>
          <button
            className="mt-3 text-[11px] text-[#999] hover:text-black"
            onClick={() => setOpen(false)}
            data-testid="agent-export-close"
          >
            [close]
          </button>
        </div>
      )}
    </span>
  );
};

export default AgentExport;
